import Core from '../plugin-core-system/core.class.js';
import CssProperties from '../helper/css-properties.helper.js';

export default class CsSectionMenu extends Core {
  static options = {};

  init() {
    this.setHealdineId();
    this.scrollSectionMenu();
    this.highlightActiveSectionMenuLinks();
  }

  setHealdineId() {
    const sectionHeadline = document.querySelector('h1');

    if (sectionHeadline) {
      sectionHeadline.closest('.frame').id = 'uebersicht';
    }
  }

  scrollSectionMenu() {
    const offsetTop = this.el.offsetTop;
    const headerHeight = Number(CssProperties.getCssPixelProperty('--header-minimized-height'));
    const triggerPoint = offsetTop - headerHeight;

    window.addEventListener('scroll', () => {
      if (window.scrollY >= triggerPoint) {
        this.el.classList.add('is-at-top');
      } else {
        this.el.classList.remove('is-at-top');
      }
    });
  }

  highlightActiveSectionMenuLinks() {
    const links = this.el.querySelectorAll('.js-section-menu-link');

    if (!links.length) {
      return;
    }

    const checkActiveLinks = () => {
      links.forEach((link) => {
        const href = link.getAttribute('href');

        if (!href || !href.startsWith('#')) {
          return;
        }

        const targetSection = document.querySelector(href);

        if (!targetSection) {
          link.classList.remove('active');
          return;
        }

        const rect = targetSection.getBoundingClientRect();
        const triggerLine = 220;

        if (rect.top <= triggerLine && rect.bottom >= triggerLine) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });

      window.addEventListener('scroll', checkActiveLinks, {passive: true});
      window.addEventListener('resize', checkActiveLinks);
    };

    checkActiveLinks();
  }
}
